import React from 'react';
import { Box } from '@chakra-ui/react';
import { Footer } from './MediaFooter';
export class HiddenBox extends React.Component {
    render() {
        return React.createElement(Box, { position: 'fixed', left: '-100000px' },
            React.createElement(Box, { w: '100%', h: '150px' },
                React.createElement(Footer, null)));
    }
}
